import React, { useEffect, useState } from "react";
import { Card, Row, Col, Button, Space, Form } from "antd";
import { useTranslation } from "react-i18next";
import FormSwitch from "components/form/FormProvide/FormSwitch";
import FormAntd from "components/form/FormProvide/FormAntd"

function AllBesmart({
   initialValues = {},
    editAllBesmart = () => { }
}) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
   const [isChange, setIsChange] = useState(false);

   useEffect(() => {
      form.setFieldsValue(initialValues);
    }, [initialValues, form]);

    const onFinish = (values) => {
     editAllBesmart(values);
  };
  return (
    <FormAntd
     form={form} 
     initialValues={initialValues}
      onFinish={onFinish}>
      <Row justify="space-between" align="middle">
        <Col>
          <h2 style={{ color: "#313131", fontWeight: 600 }}>
            {t("configBesmart.all_Besmart")}
          </h2>
          <div style={{ color: "#667085" }}>
            {t("configBesmart.Management_All_Besmart")}
          </div>
        </Col>

        <FormSwitch name="menuCodeBesmart"  />
      </Row>

      <div style={{ marginTop: 24 }}>
        <Card
          style={{
            border: "1px solid #EAECF0",
            borderRadius: 10,
            background: "#ffffff",
          }}
        >
         
           <div style={{ padding: 18, borderBottom: "1px solid #F2F4F7", position: "relative", }} >
            <span style={{ color: "#667085", fontWeight: 600 }}>
              {t("configBesmart.be_Nefit")}
            </span>
            <div style={{ color: "#A2A1A8" }}>
              {t("configBesmart.manage_Employee_Welfare")}
            </div>

            <div style={{ position: "absolute", right: 20, top: 25 }}>
              <FormSwitch name="switchbenefit"  />
            </div>
          </div>

            <div style={{ padding: 18, borderBottom: "1px solid #F2F4F7", position: "relative", }} >
            <span style={{ color: "#667085", fontWeight: 600 }}>
              {t("configBesmart.be_Perform")}
            </span>
            <div style={{ color: "#A2A1A8" }}>
              {t(
                "configBesmart.manage_Employee_Berformance_And_Results"
              )}
            </div>

            <div style={{ position: "absolute", right: 20, top: 25 }}>
              <FormSwitch name="switchbeperform"  />
            </div>
          </div>

           <div style={{ padding: 18, borderBottom: "1px solid #F2F4F7", position: "relative", }} >
            <span style={{ color: "#667085", fontWeight: 600 }}>
              {t("configBesmart.be_Findmyteam")}
            </span>
            <div style={{ color: "#A2A1A8" }}>
              {t("configBesmart.manage_Employee_Tracking_In_The_Area")}
            </div>

            <div style={{ position: "absolute", right: 20, top: 25 }}>
              <FormSwitch name="switchbefindmyteam"  />
            </div>
          </div>

         
            <div style={{ padding: 18, borderBottom: "1px solid #F2F4F7", position: "relative", }} >
            <span style={{ color: "#667085", fontWeight: 600 }}>
              {t("configBesmart.be_Timesheet")}
            </span>
            <div style={{ color: "#A2A1A8" }}>
              {t("configBesmart.manage_Employee_Time_Recording")}
            </div>

            <div style={{ position: "absolute", right: 20, top: 25 }}>
              <FormSwitch name="switchbetimesheet"  />
            </div>
          </div>

         
            <div style={{ padding: 18, borderBottom: "1px solid #F2F4F7", position: "relative", }} >
            <span style={{ color: "#667085", fontWeight: 600 }}>
              {t("configBesmart.be_Pocket")}
            </span>
            <div style={{ color: "#A2A1A8" }}>
              {t("configBesmart.employee_Data_Management")}
            </div>

            <div style={{ position: "absolute", right: 20, top: 25 }}>
              <FormSwitch name="switchbepocket"  />
            </div>
          </div>

         
           <div style={{ padding: 18, borderBottom: "1px solid #F2F4F7", position: "relative", }} >
            <span style={{ color: "#667085", fontWeight: 600 }}>
              {t("configBesmart.be_Match")}
            </span>
            <div style={{ color: "#A2A1A8" }}>
              {t("configBesmart.employee_Job_Position_Matching")}
            </div>

            <div style={{ position: "absolute", right: 20, top: 25 }}>
              <FormSwitch name="switchbematch" />
            </div>
          </div>

         
          <div style={{ padding: 18, borderBottom: "1px solid #F2F4F7", position: "relative", }} >
            <span style={{ color: "#667085", fontWeight: 600 }}>
              {t("configBesmart.be_Train")}
            </span>
            <div style={{ color: "#A2A1A8" }}>
              {t(
                "configBesmart.employee_Training_And_Skill_Development"
              )}
            </div>

            <div style={{ position: "absolute", right: 20, top: 25 }}>
              <FormSwitch name="switchbetrain" />
            </div>
          </div>
        </Card>
      </div>

     
      <Row justify="end" style={{ marginTop: 60 }}>
        <Space size={12}>
          <Button type="default" size="large" style={{ borderRadius: 8 }}>
            {t("common.cancel").toUpperCase()}
          </Button>

          <Button
            type="primary"
            size="large"
             htmlType="submit"
            style={{
              borderRadius: 8,
              backgroundColor: "var(--button-color)",
            }}
          >
            {t("confirm").toUpperCase()}
          </Button>
        </Space>
      </Row>
    </FormAntd>
  );
}

export default AllBesmart;
